import { WebApiModelsMemberField } from "../Repository/eventbookyapi";
import { mapDynamicInputLabel } from "../Mappers/mapDynamicInputLabel";
import { TextService } from "../Services/TextService";
import { MemberFieldTypes } from "../Types/MemberFieldTypes";
import { ViewType } from "../Types/ViewType";

// Columns the standard member list shows that are not member fields of their own.
const memberViewOnlyColumnTypes = [MemberFieldTypes.Membership, MemberFieldTypes.LastModified, MemberFieldTypes.Created];

// The fields that can be picked as columns for a view. Member views (ViewType.Members) also get the
// standard member list's Medlemsavgift / Senast ändrad / Skapad; the public member search does not.
export const getViewColumnFields = (viewType: number, memberFields: WebApiModelsMemberField[]): WebApiModelsMemberField[] => {
    if (viewType !== ViewType.Members) {
        return memberFields;
    }

    // Negative ids so they can never collide with a real MemberField id in the column picker.
    const viewOnlyFields = memberViewOnlyColumnTypes
        .filter(type => !memberFields.some(f => (f.columnType as any) === type))
        .map(type => ({ id: -type, columnType: type as any, visibleInAdmin: true, visiblePublic: false } as WebApiModelsMemberField));

    return [...memberFields, ...viewOnlyFields];
};

// Column title for a view column. Member views use the same titles as the standard member list.
export const getViewColumnLabel = (viewType: number | undefined, type: MemberFieldTypes, memberFields: WebApiModelsMemberField[] | null, fieldId: number | undefined | null) => {
    if (viewType === ViewType.Members && type === MemberFieldTypes.Membership) {
        return TextService.GetText("MemberList_MembershipColumn");
    }
    return mapDynamicInputLabel(type, memberFields, fieldId);
};
